var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.7918,
    height: 22.7638,
    viewBox: "0 0 22.7918 22.7638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.915,4.006,18.7568.8478a3.0773,3.0773,0,0,0-4.2422,0L10.3769,4.9855a3.0049,3.0049,0,0,0,0,4.2431l.8653.8658L10.123,11.2135l-.8662-.8657a3.0773,3.0773,0,0,0-4.2422,0L.8769,14.4855a3.0049,3.0049,0,0,0,0,4.2431l3.1582,3.1592a3.0047,3.0047,0,0,0,4.2422-.001l4.1377-4.1377a3.0052,3.0052,0,0,0,0-4.2431l-.8779-.8784,1.1191-1.1192.8789.8794a3.0047,3.0047,0,0,0,4.2422-.001L21.915,8.2491A3.0052,3.0052,0,0,0,21.915,4.006ZM11.001,14.92a1.0028,1.0028,0,0,1,0,1.4151L6.8633,20.4723a1.03,1.03,0,0,1-1.4141,0L2.291,17.3141a1.0051,1.0051,0,0,1,0-1.4146l4.1377-4.1382a1.0057,1.0057,0,0,1,1.4141,0l.8662.8663L6.456,14.8805,7.87,16.2941l2.2529-2.2525Zm9.5-8.0849-4.1377,4.1372a1.03,1.03,0,0,1-1.4141,0l-.8789-.8789,1.8-1.8L14.456,6.8805l-1.8,1.7993-.8652-.8657a1.0051,1.0051,0,0,1,0-1.4146l4.1377-4.1382a1.0057,1.0057,0,0,1,1.4141,0L20.501,5.42A1.0028,1.0028,0,0,1,20.501,6.8351Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.1699,
    y: 14.5875,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.1699,
    y: 18.5875,
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.1699,
    y: 6.5875,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.1699,
    y: 1.5875,
    width: 2,
    height: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroken);
export default __webpack_public_path__ + "static/media/broken.259d402be6f57fab20a1956c2cb032ca.svg";
export { ForwardRef as ReactComponent };